import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on every route change. Preserves in-page anchor jumps (#hash).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let the browser handle #anchor scrolling
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
